import PropTypes from 'prop-types';
import { Button, Modal } from '@bwoty-web/ui-kit';

import errorTypes from '../../../constants/errorTypes';

import './errorPopup.scss';

const ErrorPopup = ({ closePopup, labels, error }) => {
  let title = null;
  let text = null;
  let buttonText = null;
  let buttonLink = error.buttonUrl;

  const deleteParams = (searchParams) => {
    searchParams.delete('SessionId');
    searchParams.delete('TransportKey');
    searchParams.delete('TransportId');
    searchParams.delete('AccomodationKeys');
    searchParams.delete('AccBookKey');
  };

  switch (error.errorType) {
    case errorTypes.SESSION_EXPIRED: {
      title = labels.sessionExpired.heading;
      text = labels.sessionExpired.message;
      buttonText = labels.sessionExpired.buttonLabel;

      if (!buttonLink) {
        const searchParams = new URLSearchParams(window.location.search);
        deleteParams(searchParams);
        buttonLink = `${window.location.pathname}?${searchParams}`;
      }

      if (error.navigateBack) {
        if (document?.referrer?.length > 0) {
          const previousUrl = new URL(document.referrer);
          const { pathname, searchParams } = previousUrl;
          deleteParams(searchParams);
          buttonLink = `${pathname}?${searchParams}`;
        } else {
          buttonLink = '/';
        }
      }

      break;
    }

    case errorTypes.SYSTEM_ERROR:
      title = labels.systemError.heading;
      text = error.message;
      break;

    case errorTypes.SYSTEM_ERROR_TRANSLATED:
      title = error.title;
      text = error.message;
      break;

    default:
      title = null;
      text = null;
  }

  const handleClose = () => {
    if (buttonLink) {
      window.location = buttonLink;
    }
    closePopup();
  };

  const message = (
    <div className="iw-error-popup">
      <div className="iw-error-popup__text">{text}</div>
      {buttonText && buttonLink && (
        <Button variant="primary" href={buttonLink} size="s">
          {buttonText}
        </Button>
      )}
    </div>
  );

  return (
    <Modal heading={title} isOpen={error.visible} onClose={() => handleClose()}>
      {message}
    </Modal>
  );
};

ErrorPopup.propTypes = {
  labels: PropTypes.shape({
    sessionExpired: PropTypes.shape({
      heading: PropTypes.string,
      message: PropTypes.string,
      buttonLabel: PropTypes.string,
    }),
    systemError: PropTypes.shape({
      heading: PropTypes.string,
    }),
  }).isRequired,
  closePopup: PropTypes.func.isRequired,
  error: PropTypes.shape({
    buttonUrl: PropTypes.string,
    errorType: PropTypes.string,
    message: PropTypes.string,
    navigateBack: PropTypes.bool,
    title: PropTypes.string,
    visible: PropTypes.bool,
  }).isRequired,
};

export default ErrorPopup;
